export enum DocumentType {
  Picture = 'Picture',
  EmployeeProfilePicture = 'EmployeeProfilePicture',
  Cv = 'CV',
  MotivationLetter = 'MotivationLetter',
  Contract = 'Contract',
  Certificate = 'Certificate',
  CertifiedCertificate = 'CertifiedCopyUEC',
  Other = 'Other',
  CertificateGermanSkills = 'Certificate German skills',
  DeRegistrationCertificate = 'De-registration certificate',
}
